import { render, staticRenderFns } from "./ArticleRelatedHeadlinesSection.vue?vue&type=template&id=503b8aca&scoped=true&"
import script from "./ArticleRelatedHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleRelatedHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleRelatedHeadlinesSection.vue?vue&type=style&index=0&id=503b8aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b8aca",
  null
  
)

export default component.exports